
import { RSAA } from "redux-api-middleware";
import config from "config";

export const UPDATE_CLOSE_REASON_REQUEST = "UPDATE_CLOSE_REASON_REQUEST";
export const UPDATE_CLOSE_REASON_SUCCESS = "UPDATE_CLOSE_REASON_SUCCESS";
export const UPDATE_CLOSE_REASON_FAILURE = "UPDATE_CLOSE_REASON_FAILURE";

export const updateCloseReason = (wfItemId, closeReason) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/swim/${wfItemId}/close-reason`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ closeReason }),
      types: [
        UPDATE_CLOSE_REASON_REQUEST,
        {
          type: UPDATE_CLOSE_REASON_SUCCESS,
          payload: async (action, state, res) => {
            const data = await res.json(); // The payload should include the globalSwitchId to find the item in the reducer
            return { ...data, wfItemId };
          }
        },
        UPDATE_CLOSE_REASON_FAILURE,
      ],
    },
  };
};
